import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"max-height":"450px"} }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { style: {"max-height":"100vh","overflow-y":"auto","overflow-x":"hidden","flex-grow":"1"} }
const _hoisted_5 = { style: {"max-height":"100vh","overflow-y":"auto","overflow-x":"hidden","flex-grow":"1"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_SignUpForm = _resolveComponent("SignUpForm")!
  const _component_ForgotPasswordForm = _resolveComponent("ForgotPasswordForm")!
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!
  const _component_PersonalProfile = _resolveComponent("PersonalProfile")!
  const _component_SelectServiceForm = _resolveComponent("SelectServiceForm")!
  const _component_IDOverview = _resolveComponent("IDOverview")!
  const _component_ActivateForm = _resolveComponent("ActivateForm")!
  const _component_SignInForm = _resolveComponent("SignInForm")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_TimeOutAlert = _resolveComponent("TimeOutAlert")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_v_theme_provider = _resolveComponent("v-theme-provider")!

  return (_openBlock(), _createBlock(_component_v_theme_provider, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app, {
        id: "v-app",
        app: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            height: "100vh",
            cover: "",
            src: _ctx.background
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                style: {"max-height":"100vh","overflow-y":"auto","overflow-x":"hidden","flex-grow":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { style: {"height":"15vh"} }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        style: {"max-height":"85vh","overflow-y":"auto","overflow-x":"hidden","flex-grow":"1"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            align: "center",
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                "max-width": "420px",
                                "max-height": "650px",
                                variant: "elevated",
                                hover: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { align: "center" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Polteq ID - " + _toDisplayString(_ctx.i18n.t('app.title')) + " ", 1),
                                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                      _createVNode(_component_v_avatar, { density: "comfortable" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            height: "32",
                                            width: "32",
                                            alt: "polteq-id logo",
                                            src: require('@/assets/polteq_id.png')
                                          }, null, 8, _hoisted_1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_router_link, {
                                        style: _normalizeStyle(_ctx.i18n.locale.value !== 'nl' ? 'text-decoration: none !important;' : ''),
                                        to: "",
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLocale('nl')))
                                      }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                          _createTextVNode(" NL ")
                                        ])),
                                        _: 1
                                      }, 8, ["style"]),
                                      _cache[10] || (_cache[10] = _createTextVNode(" | ")),
                                      _createVNode(_component_router_link, {
                                        style: _normalizeStyle(_ctx.i18n.locale.value !== 'en' ? 'text-decoration: none !important;' : ''),
                                        to: "",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLocale('en')))
                                      }, {
                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                          _createTextVNode(" EN ")
                                        ])),
                                        _: 1
                                      }, 8, ["style"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, {
                                    opacity: "100",
                                    thickness: 1,
                                    color: "success"
                                  }),
                                  _createElementVNode("div", _hoisted_2, [
                                    (_ctx.navigationStore.form === _ctx.Forms.SIGN_UP)
                                      ? (_openBlock(), _createBlock(_component_SignUpForm, { key: 0 }))
                                      : (_ctx.navigationStore.form === _ctx.Forms.FORGOT_PASSWORD)
                                        ? (_openBlock(), _createBlock(_component_ForgotPasswordForm, { key: 1 }))
                                        : (_ctx.navigationStore.form === _ctx.Forms.CHANGE_PASSWORD)
                                          ? (_openBlock(), _createBlock(_component_ChangePasswordForm, { key: 2 }))
                                          : (_ctx.navigationStore.form === _ctx.Forms.RESET_PASSWORD)
                                            ? (_openBlock(), _createBlock(_component_ResetPasswordForm, { key: 3 }))
                                            : (_ctx.navigationStore.form === _ctx.Forms.PROFILE)
                                              ? (_openBlock(), _createBlock(_component_PersonalProfile, { key: 4 }))
                                              : (_ctx.navigationStore.form === _ctx.Forms.SERVICES)
                                                ? (_openBlock(), _createBlock(_component_SelectServiceForm, { key: 5 }))
                                                : (_ctx.navigationStore.form === _ctx.Forms.SIGNED_IN)
                                                  ? (_openBlock(), _createBlock(_component_IDOverview, { key: 6 }))
                                                  : (_ctx.navigationStore.form === _ctx.Forms.ACTIVATE)
                                                    ? (_openBlock(), _createBlock(_component_ActivateForm, { key: 7 }))
                                                    : (_openBlock(), _createBlock(_component_SignInForm, { key: 8 }))
                                  ]),
                                  _createVNode(_component_v_divider, {
                                    opacity: "100",
                                    thickness: 1,
                                    color: "success"
                                  }),
                                  _createVNode(_component_v_card_text, { align: "right" }, {
                                    default: _withCtx(() => [
                                      (
                        _ctx.navigationStore.form === '' ||
                          _ctx.navigationStore.form === _ctx.Forms.SIGN_IN ||
                          _ctx.navigationStore.form === _ctx.Forms.ACTIVATE ||
                          _ctx.navigationStore.form === _ctx.Forms.RESET_PASSWORD ||
                          _ctx.navigationStore.form === _ctx.Forms.FORGOT_PASSWORD
                      )
                                        ? (_openBlock(), _createBlock(_component_PolteqButton, {
                                            key: 0,
                                            "button-id": "goToCreateAccountButton",
                                            icon: "mdi-account-plus-outline",
                                            "button-text": _ctx.i18n.t('texts.newuser'),
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.SIGN_UP)))
                                          }, null, 8, ["button-text"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.navigationStore.form === _ctx.Forms.SIGN_UP)
                                        ? (_openBlock(), _createBlock(_component_PolteqButton, {
                                            key: 1,
                                            "button-id": "goHomeButton",
                                            icon: "mdi-home-outline",
                                            "button-text": _ctx.i18n.t('texts.homepage'),
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.SIGN_IN)))
                                          }, null, 8, ["button-text"]))
                                        : _createCommentVNode("", true),
                                      (
                        _ctx.navigationStore.form === _ctx.Forms.SERVICES ||
                          _ctx.navigationStore.form === _ctx.Forms.PROFILE ||
                          _ctx.navigationStore.form === _ctx.Forms.CHANGE_PASSWORD
                      )
                                        ? (_openBlock(), _createBlock(_component_PolteqButton, {
                                            key: 2,
                                            "button-id": "goToAccountButton",
                                            icon: "mdi-skip-backward-outline",
                                            "button-text": _ctx.i18n.t('texts.toaccount'),
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.SIGNED_IN)))
                                          }, null, 8, ["button-text"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.navigationStore.form !== _ctx.Forms.SIGN_IN && _ctx.navigationStore.form !== _ctx.Forms.SIGNED_IN)
                                        ? (_openBlock(), _createElementBlock("br", _hoisted_3))
                                        : _createCommentVNode("", true),
                                      (_ctx.userStore.userInfo.email !== '')
                                        ? (_openBlock(), _createBlock(_component_PolteqButton, {
                                            key: 4,
                                            "button-id": "logoutButton",
                                            icon: "mdi-logout",
                                            "button-text": _ctx.i18n.t('buttons.signout') + ' ' + _ctx.userStore.userInfo.preferredUsername,
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.AuthenticationHelper.logout(_ctx.router)))
                                          }, null, 8, ["button-text"]))
                                        : _createCommentVNode("", true),
                                      (
                        _ctx.navigationStore.form === _ctx.Forms.SIGN_UP ||
                          _ctx.navigationStore.form === _ctx.Forms.ACTIVATE ||
                          _ctx.navigationStore.form === _ctx.Forms.RESET_PASSWORD ||
                          _ctx.navigationStore.form === _ctx.Forms.FORGOT_PASSWORD
                      )
                                        ? (_openBlock(), _createBlock(_component_PolteqButton, {
                                            key: 5,
                                            "button-id": "existingUserButton",
                                            icon: "mdi-login",
                                            "button-text": _ctx.i18n.t('texts.existinguser'),
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.SIGN_IN)))
                                          }, null, 8, ["button-text"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portalStateStore.notificationMessages, (notificationMessage) => {
                          return (_openBlock(), _createBlock(_component_TimeOutAlert, {
                            key: notificationMessage.uuid,
                            "notification-message": notificationMessage
                          }, null, 8, ["notification-message"]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portalStateStore.notificationMessages, (notificationMessage) => {
                          return (_openBlock(), _createBlock(_component_TimeOutAlert, {
                            key: notificationMessage.uuid,
                            "notification-message": notificationMessage
                          }, null, 8, ["notification-message"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["src"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}